// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-more-surface {\n  width: calc(100vw - 24px);\n  max-width: 420px;\n  max-height: calc(100vh - 112px);\n  overflow: auto;\n  border: 1px solid var(--portal-border);\n  border-radius: var(--portal-radius-md) !important;\n  background: var(--portal-surface);\n  box-shadow: 0 18px 44px rgba(16, 17, 15, 0.18) !important;\n}", ""]);
// Exports
module.exports = exports;
